import { Component } from '@angular/core';
import '@angular/localize/init';
import { FirebaseService } from './core/services/firebase.service';
import { SessionStorageService } from './shared/services/session-storage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'alfa-force-crm';

  constructor(private readonly firebaseService: FirebaseService, private readonly sessionStorageService: SessionStorageService) {
    this.firebaseService.listenToMessages();
  }
}
